<template>
  <div>
    <div class="bo_title mb-6" v-text="'Gestion des workflows'" />
    <Board class="mb-6">
      <template #header class="mb-6">
        <div class="d-flex justify-space-between align-center">
          <!-- Create workflow button -->
          <BaseButton
            icon="$mdiPlus"
            @click="
              $store.commit(
                'workflow/setModalCreateAndEditWorkflowDialog',
                true
              )
            "
          >
            <span v-text="$t('workflow.createNewWorkflow')" />
          </BaseButton>
          <div>
            <v-text-field
              v-model="filters.name"
              outlined
              :label="$t('folder.search')"
              prepend-inner-icon="$mdiMagnify"
              dense
              hide-details
              @input="handleInputFilter"
            />
          </div>
        </div>
      </template>
      <template #main>
        <div>
          <div class="workflow_list">
            <div class="workflow_list_header">
              <div
                v-for="(value, i) in TABLE_HEADER"
                :key="i"
                class="header_item"
                :class="value.className"
              >
                {{ value.text }}
              </div>
            </div>
            <div class="workflow_list_items">
              <router-link
                v-for="(item, i) in workflows.items"
                :key="i"
                tag="a"
                class="workflow_item"
                :to="{
                  name: 'workflowDetail',
                  params: {
                    workflowId: `${item.id}`,
                  },
                }"
              >
                <div class="item_content" v-text="item.name" />
                <div class="item_content text-center" v-text="item.nbFolders" />
                <div class="item_content">
                  <div
                    class="text-center"
                    v-text="$d(new Date(item.dateCreated), 'veryshort')"
                  />
                </div>
                <div class="item_content">
                  <div
                    v-if="item.lastFolderDateCreated"
                    class="text-center"
                    v-text="
                      $d(new Date(item.lastFolderDateCreated), 'veryshort')
                    "
                  />
                  <div v-else class="text-center" v-text="'--'" />
                </div>

                <div class="item_content">
                  <div class="state_item">
                    <div
                      class="state_icon"
                      :class="{
                        disabled: !item.nexusFolderCreationEnabled,
                      }"
                    >
                      <BaseIcon
                        v-if="item.nexusFolderCreationEnabled"
                        icon="$mdiCheck"
                        color="white"
                        small
                      />
                      <BaseIcon v-else icon="$close" color="white" small />
                    </div>
                  </div>
                </div>
                <div class="item_content">
                  <div class="state_item">
                    <div
                      class="state_icon"
                      :class="{
                        disabled: !item.sendCollectionEmails,
                      }"
                    >
                      <BaseIcon
                        v-if="item.sendCollectionEmails"
                        icon="$mdiCheck"
                        color="white"
                        small
                      />
                      <BaseIcon v-else icon="$close" color="white" small />
                    </div>
                  </div>
                </div>
                <div class="item_content">
                  <div
                    class="text-center"
                    v-text="
                      item.inactivityDaysLimit ? item.inactivityDaysLimit : '--'
                    "
                  />
                </div>
                <div class="item_content action">
                  <div class="action_section">
                    <BaseButtonIcon
                      v-if="!item.nbFolders"
                      x-small
                      color="secondary"
                      icon="$mdiTrashCanOutline"
                      @click.stop="openDeleteWorkflowDialogFunc(item)"
                    />
                  </div>
                </div>
              </router-link>
              <template v-if="filters.loading">
                <div
                  v-for="value in 5"
                  :key="`sq-${value}`"
                  class="workflow_skeleton"
                >
                  <v-skeleton-loader class="skeleton" type="text" />
                </div>
              </template>
              <div v-else-if="!workflows.items.length" class="no_data_section">
                {{ $t("utils.no_workflow_found") }}
              </div>
              <div
                v-if="!filters.loading && workflows.next"
                class="show_more_action"
              >
                <v-btn text color="primary" @click="loadMoreWorkflows()">
                  {{ $t("utils.show_more") }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Board>

    <WorkflowCreateAndEditDialog />
    <WorkflowDeleteDialog
      :dialog-state="openDeleteWorkflowDialog"
      :workflow="activeWorkflow"
      @worflowDeleted="handleWorflowDeleted"
      @close="openDeleteWorkflowDialog = false"
    />
  </div>
</template>

<script>
import Board from "@/core/Components/Board";
import WorkflowCreateAndEditDialog from "@/modules/Admin/Components/WorkflowCreateAndEditDialog";
import WorkflowDeleteDialog from "@/modules/Admin/Components/WorkflowDeleteDialog";
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";

export default {
  name: "WorkflowList",
  components: {
    Board,
    WorkflowCreateAndEditDialog,
    WorkflowDeleteDialog,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      TABLE_HEADER: [
        {
          text: this.$t("utils.workflow_name"),
          value: "name",
        },
        {
          text: this.$t("utils.folders_count"),
          value: "folders_count",
          className: "center",
        },
        {
          text: this.$t("utils.created_date"),
          value: "created_date",
          className: "center",
        },
        {
          text: this.$t("utils.last_created_folder"),
          value: "last_created_folder",
          className: "center",
        },
        {
          text: this.$t("utils.nexus_creation"),
          value: "nexus_creation",
          className: "center",
        },
        {
          text: this.$t("utils.send_auto_mail"),
          value: "send_auto_mail",
          className: "center",
        },
        {
          text: this.$t("utils.alert_inativity"),
          value: "alert_inativity",
          className: "center",
        },
        {
          text: this.$tc("utils.action", 1),
          value: "action",
          className: "action center",
        },
      ],
      workflows: {
        items: [],
        count: 0,
        next: 0,
        previous: 0,
      },
      filters: {
        loading: false,
        page: 1,
        pageSize: 10,
        name: undefined,
      },
      searchTimeoutRef: undefined,
      openDeleteWorkflowDialog: false,
      activeWorkflow: null,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.fetchWorkflows();
    },
    async fetchWorkflows() {
      this.filters.loading = true;
      try {
        const res = await WorkflowAPI.getOrganizationWorkflows({
          organizationId: this.organizationId,
          params: {
            page: this.filters.page,
            name: this.filters.name || "",
            page_size: this.filters.pageSize,
          },
        });
        this.workflows = {
          ...res.data,
          items: [...this.workflows.items, ...res.data.results],
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.filters.loading = false;
    },
    handleInputFilter() {
      this.filters.page = 1;
      if (this.searchTimeoutRef) clearTimeout(this.searchTimeoutRef);
      this.searchTimeoutRef = setTimeout(async () => {
        this.workflows.items = [];
        this.fetchWorkflows();
      }, 500);
    },
    loadMoreWorkflows() {
      this.filters.page = this.workflows.next;
      this.fetchWorkflows();
    },
    openDeleteWorkflowDialogFunc(workflow) {
      this.activeWorkflow = workflow;
      this.openDeleteWorkflowDialog = true;
    },
    handleWorflowDeleted(workfowId) {
      this.workflows.items = this.workflows.items.filter(
        (wf) => wf.id !== workfowId
      );
      this.workflows.count -= 1;
      this.activeWorkflow = null;
    },
  },
};
</script>

<style scoped lang="scss">
.tab_row {
  cursor: pointer;
  .state_item {
    display: flex;
    justify-content: center;
    .state_icon {
      cursor: pointer;
      width: 20px;
      height: 20px;
      font-family: "Inter";
      font-size: 13px;
      line-height: 13px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #18a300;
      border-radius: 50%;
      &.disabled {
        cursor: auto;
        background: #ff5267;
      }
    }
  }
  .action_section {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
  }
}
.workflow_list {
  .workflow_list_header {
    display: flex;
    align-items: center;
    .header_item {
      flex: none;
      width: calc(calc(100% - 56px) / 7);
      color: #353542;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      padding: 18px 6px;
      &.action {
        width: 56px;
      }
      &.center {
        text-align: center;
      }
    }
  }
  .workflow_list_items {
    .workflow_item {
      display: flex;
      align-items: center;
      width: 100%;
      text-decoration: none;
      border-top: 1px solid #e5e5e5;
      background: #fff;
      cursor: pointer;
      transition: all 0.25s;
      &:hover {
        background: #f5f5f5;
      }
      &:last-child {
        border-bottom: 1px solid #e5e5e5;
      }
      .state_item {
        display: flex;
        justify-content: center;
        .state_icon {
          cursor: pointer;
          width: 20px;
          height: 20px;
          font-family: "Inter";
          font-size: 13px;
          line-height: 13px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #18a300;
          border-radius: 50%;
          &.disabled {
            cursor: auto;
            background: #ff5267;
          }
        }
      }
      .action_section {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 2px;
      }
      .item_content {
        padding: 8px;
        flex: none;
        width: calc(calc(100% - 56px) / 7);
        color: #353542;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        line-height: 18px;
        padding: 18px 12px;
        &.action {
          width: 56px;
        }
        &.center {
          text-align: center;
        }
      }
    }
    .workflow_skeleton {
      width: 100%;
      margin-bottom: 8px;
      height: 60px;
      .skeleton {
        height: 100%;
        width: 100%;
        ::v-deep {
          .v-skeleton-loader__bone {
            height: 100%;
          }
        }
      }
    }
    .no_data_section {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 18px 12px;
      width: 100%;
      border-top: 1px solid #e5e5e5;
      border-bottom: 1px solid #e5e5e5;
      background: #fff;
      color: #999;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
    }
    .show_more_action {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 18px 12px;
      text-decoration: underline;
    }
  }
}
</style>
